import { useEffect, useState } from 'react';
import { api, type JournalistRow } from '../api';

export function Journalists() {
  const [rows, setRows] = useState<JournalistRow[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [query, setQuery] = useState('');

  useEffect(() => {
    api.journalists().then((result) => setRows(result.rows)).catch((err: Error) => setError(err.message));
  }, []);

  const filtered = rows.filter((row) => row.canonical_name.toLowerCase().includes(query.toLowerCase()));

  return (
    <section className="panel">
      <div className="toolbar">
        <label>
          <span>Search</span>
          <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Name or outlet" />
        </label>
        <button type="button">Export CSV</button>
      </div>
      {error && <p className="error">{error}</p>}
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Outlet</th>
              <th>Nationality</th>
              <th>Tier</th>
              <th>VN articles</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((row) => (
              <tr key={row.id}>
                <td>{row.canonical_name}</td>
                <td>{row.primary_outlet ?? 'Unassigned'}</td>
                <td>{row.nationality_code ?? row.nationality_inferred ?? 'Unknown'}</td>
                <td>{row.triage_tier ?? 'Pending'}</td>
                <td>{row.vietnam_articles_count}</td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={5}>No journalist rows yet.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
